export type SkeletonProps = {
  width?: string | number;
  height?: string | number;
  shape?: "line" | "block" | "circle";
  className?: string;
  lines?: number;
};

export function Skeleton({ width, height, shape = "line", className, lines = 1 }: SkeletonProps) {
  const style = { width, height };

  if (lines > 1) {
    return (
      <span className="fxmap-skeleton-group" aria-hidden="true">
        {Array.from({ length: lines }, (_, index) => (
          <span key={index} className={["fxmap-skeleton", `fxmap-skeleton-${shape}`, index === lines - 1 ? "fxmap-skeleton-short" : "", className ?? ""].filter(Boolean).join(" ")} style={style} />
        ))}
      </span>
    );
  }

  return <span className={["fxmap-skeleton", `fxmap-skeleton-${shape}`, className ?? ""].filter(Boolean).join(" ")} style={style} aria-hidden="true" />;
}
